import { render, staticRenderFns } from "./Carroussel3.vue?vue&type=template&id=782b88e3&scoped=true"
import script from "./Carroussel3.vue?vue&type=script&lang=js"
export * from "./Carroussel3.vue?vue&type=script&lang=js"
import style0 from "./Carroussel3.vue?vue&type=style&index=0&id=782b88e3&prod&scoped=true&lang=css"
import style1 from "./Carroussel2.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782b88e3",
  null
  
)

export default component.exports